import React, { useState, useEffect, useRef } from "react";
import Header from "../Components/Header";
import { isMobile } from "react-device-detect";
import { useParams, Link, useNavigate } from "react-router-dom";
import Footer from "../Components/Footer";
import axios from "axios";
import { toast } from "react-toastify";

const Message = () => {
    const { id } = useParams();

    const navigate = useNavigate();

    const token = localStorage.getItem("token");
    
    const axiosInstance = axios.create({
      baseURL: `/${id}/v3`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const [locked, setLocked] = useState(false);

    const [activeTab, setActiveTab] = useState("Chat");

    const tabs = ["Chat", "Email", "SMS", "All"];

    const [activesideTab, setActiveSideTab] = useState("Teachers");

    const teachers = [
      { id: 1, name: "Mr. Smith", message: "Ready for class updates" },
      { id: 2, name: "Mrs. Johnson", message: "Uploaded new materials" },
    ];
    const students = [
      { id: 1, name: "Alice Doe", message: "Asked a question" },
      { id: 2, name: "Bob Smith", message: "Completed the quiz" },
    ];
    const classGroups = [
      { id: 1, name: "Grade 1", message: "5 students online" },
      { id: 2, name: "Grade 2", message: "Active discussion" },
    ];

    const classNames = [
      "Preparatory 1", "Preparatory 2", "Reception 1", "Reception 2",
      "PlayGroup", "NUR 1", "NUR 2", "KG 1", "KG 2",
      "Grade 1", "Grade 2", "Grade 3", "Grade 4", "Grade 5", "Grade 6",
      "Jss1", "Jss2", "Jss3", "sss1", "sss2", "sss3",
    ];

    const [activeClass, setActiveClass] = useState(null);
    const [activeStudentId, setActiveStudentId] = useState(null);
    const [lastMessage, setLastMessage] = useState("");

    const [inputMessage, setInputMessage] = useState("");
      
    const handlePromptClick = (title, message) => {
        setInputMessage(`${title} - ${message}`);
    };

    // Fetch last message from backend when a class is selected
    useEffect(() => {
      const fetchLastMessage = async () => {
        if (!activeClass) return;
        try {
          const res = await axios.post("/chats", { class: activeClass });
          const messages = res.data.messages;
          if (Array.isArray(messages) && messages.length > 0) {
            setLastMessage(messages[messages.length - 1].text);
          } else {
            setLastMessage("No message yet");
          }
        } catch (err) {
          console.error("Error fetching messages", err);
          setLastMessage("Failed to load");
        }
      };

      fetchLastMessage();
    }, [activeClass]);

    // Send message
    const handleSend = async () => {
      if (!inputMessage.trim()) {
        toast.warn("Message cannot be empty");
        return;
      }

      try {
        const payload = {
          text: inputMessage,
          sender_type: "admin",
          channel: activeTab.toLowerCase(),
        };

        if (activeClass) {
          payload.class = activeClass;
          payload.broadcast = true;
        }

        if (activeStudentId) {
          payload.stud_id = activeStudentId;
          payload.broadcast = false;
        }

        await axiosInstance.post("/chat", payload);

        toast.success("Message sent!");
        setLastMessage(inputMessage);
        setInputMessage("");
      } catch (err) {
        console.error("Error sending message", err);
        toast.error("Failed to send message");
      }
    };

    const renderList = () => {
      return classNames.map((cls, index) => {
        const isActive = activeClass === cls;
        // short message truncation if you want
        const shortMsg =
          lastMessage?.length > 40 ? lastMessage.slice(0, 40) + "..." : lastMessage;

        return (
          <li
            key={index}
            className={`card cursor-pointer px-3 py-2 mb-2 ${
              isActive ? "bg-back text-dark" : "bg-white text-dark"
            } shadow-none border-light border-bottom`}
             style={{
                    borderRadius: "20px",
                  }}
            onClick={() => setActiveClass(cls)}
          >
            <div className={`row align-items-center px-3 py-3 ${isActive ? "text-dark" : "text-dark"}`}>
              <div className="col-4 d-flex align-items-center justify-content-center">
                <span className="avatar avatar-md shadow-none">
                  <img
                    alt="avatar"
                    src="../assets/images/background/class1.png"
                    className="rounded-3"
                  />
                </span>
              </div>

              <div className="col-8 ms-n3">
                <div className="fs-5">{cls}</div>
                <div className={`fs-6 mt-1 ${isActive ? "text-gray-600" : "text-gray-600"}`}>
                  {isActive ? shortMsg : ""}
                </div>
              </div>
            </div>
          </li>
        );
      });
    };

    const promptMessages = [
    {
      title: "#SchoolFTGS - Family Trivia Game Show!",
      message: "A fun quiz for families of our students. Compete, bond, and win exciting prizes.",
    },
    {
      title: "#SchoolShareNWin - Referral Challenge!",
      message: "Refer new students to our school and stand a chance to win cash and gift prizes.",
    },
    {
      title: "#SchoolWinBig - Social Media Fun!",
      message: "Invite friends to follow our pages and engage. They win, you win.",
    },
    {
      title: "#SchoolPromo - Share And Earn!",
      message: "Post our school's content on your social pages and stand a chance to win exclusive promo gifts.",
    },
  ];

 
  return (
    <div className="bg-back d-flex flex-column min-vh-100">
      <Header />

      { locked ? 
      <>
      <div
      className="docs-nav-sidebar border-none bg-purple4 shadow-none"
      style={{ width: "80px", border: "none" }}
      >

      <div className="nav-top border-0 py-0 mt-6">
        <nav className="navbar navbar-expand-lg px-0 text-center">
         
        </nav>
      </div>

        <div className="docs-nav" data-simplebar>
          <nav className="navbar navbar-expand-lg">
            <div className="collapse navbar-collapse mb-0 mt-8" id="navbarNav">
              <ul className="navbar-nav flex-column text-start px-0 shadow-none" id="sidebarnav">
                <li className="nav-item text-center mb-4">
                  <Link to="/home" className="text-white" title="Home">
                    <i className="bi bi-house fs-3 d-block mb-1"></i>
                    <small>Home</small>
                  </Link>
                </li>
                <li className="nav-item text-center mb-4">
                  <Link to="/pricing" className="text-white" title="Pricing">
                    <i className="bi bi-wallet fs-3 d-block mb-1"></i>
                    <small>Pricing</small>
                  </Link>
                </li>
                <li className="nav-item text-center mb-4">
                  <Link to="/configure" className="text-white" title="Configure">
                    <i className="bi bi-sliders fs-3 d-block mb-1"></i>
                    <small>Configure</small>
                  </Link>
                </li>
                <li className="nav-item text-center mb-4">
                  <Link to="/more" className="text-white" title="More">
                    <i className="bi bi-three-dots fs-3 d-block mb-1"></i>
                    <small>More</small>
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>

      <div
        className="docs-nav-sidebar border bg-white shadow-sm p-3"
        style={{ width: "300px", left: "80px" }}
      >
       
      <div className="nav-top border-0 py-0 mt-9">
        <nav className="px-3">
          <div className="mb-3">
            <div className="fw-medium fs-t text-dark mb-0">Chats</div>
          </div>
          {/* Tabs */}
          <div className="d-flex justify-content-between mb-3 pb-2 text-center">
            {["Teachers", "Students", "Classes"].map((tab) => (
              <div
                key={tab}
                className={`cursor-pointer ${
                  activesideTab === tab ? "badge bg-dark rounded-pill me-4" : "text-gray-600 fs-5 me-4"
                }`}
                onClick={() => setActiveSideTab(tab)}
              >
                {tab}
              </div>
            ))}
          </div>
        </nav>
      </div>

        <div className="docs-nav" data-simplebar>
          <nav className="navbar navbar-expand-lg">
            <div className="collapse navbar-collapse mb-0" id="navbarNav">
              {/* Content */}
              <ul className="navbar-nav flex-column text-start px-0 shadow-none mb-4" id="sidebarnav">
                {activesideTab === "Teachers" && renderList(teachers)}
                {activesideTab === "Students" && renderList(students)}
                {activesideTab === "Classes" && renderList(classGroups)}
              </ul>
            </div>
          </nav>
        </div>
      </div>

      <div className="docs-wrapper bg-white" 
      style={isMobile ? {} : { left: "95px", width: "calc(100% - 300px)" }}>
        <div className="docs-content">
          <div className="py-20">
            <div className="row">
              <div className="col-12 col-lg-12">

                <div className="fixed-top d-flex justify-content-buttom align-items-center shadow-none mt-10"
                style={isMobile ? {} : { left: "380px"}}>
                  <div className="border-0 w-100">
                    <div className="bg-back py-3 px-4 px-lg-4">
                      <div
                        className="d-flex align-items-center"
                      >
                        <div className="col-10">
                        <div className="d-flex align-items-center">
                          
                          <div className="col-auto">
                          <div className="mb-0">
                            <span className="text-dark fs-3">
                              {activeClass} Class
                            </span>
                            <div className="text-dark fs-5">
                               <i className="bi bi-people-fill text-purple3 me-1"></i>
                               {" 20 Students"}
                            </div>
                          </div>
                          </div>
                        </div>
                        </div>

                        <div className="col-2 text-end cursor-pointer">
                          <div className="text-dark fs-t">
                            <i class="bi bi-arrow-90deg-left"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Message Prompt Section */}
                <div className="px-lg-10">
                  <div className="text-center">
                  {promptMessages.map((prompt, index) => (
                    <div
                      key={index}
                      className="ms-4 btn btn-md btn-outline-dark mb-3 cursor-pointer rounded-pill"
                      onClick={() => handlePromptClick(prompt.title, prompt.message)}
                    >
                      {prompt.title}
                    </div>
                  ))}
                  </div>
                </div>

                
                <div className="fixed-bottom d-flex justify-content-buttom align-items-center shadow-none mb-n4"
                style={isMobile ? {} : { left: "390px"}}>
                  <div className="border-0 w-100">
                    <div className="px-4 px-lg-5 py-3">
                      <div
                        className="border bg-white rounded-4 px-4 py-3"
                        style={{ minHeight: "60px" }}
                      >
                        {/* Tabs */}
                        <div className="d-flex mb-2 pb-2">
                          {tabs.map((tab) => (
                            <div
                              key={tab}
                              className={`me-4 pb-2 cursor-pointer ${
                                activeTab === tab
                                  ? "border-bottom border-dark fw-semibold text-dark"
                                  : "text-muted"
                              }`}
                              onClick={() => setActiveTab(tab)}
                            >
                              {tab}
                            </div>
                          ))}
                        </div>

                    
                        {/* Input area */}
                        <div className="border-0 rounded-4 bg-white">
                          {/* Input area with input on top, buttons below */}
                          <div className="d-flex flex-column">
                            {/* Text Input */}
                            <textarea
                              type="text"
                              placeholder="Type your message..."
                              value={inputMessage}
                              onChange={(e) => setInputMessage(e.target.value)}
                              className="form-control text-dark border-0 shadow-none rounded-pill px-4 py-2"
                            ></textarea>

                            {/* AI + Send Button */}
                            <div className="d-flex justify-content-between align-items-center mt-0 px-0">
                              <span className="badge bg-purple text-white">
                                <i className="bi bi-stars text-warning me-1"></i>
                                Smart AI
                              </span>
                              <button className="btn btn-purple btn-icon rounded-circle"
                              onClick={handleSend}>
                                <i className="bi bi-send text-white fs-5"></i>
                              </button>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>

      :

      <>
      <div className="container-fluid">
        <div className="row px-2 px-lg-15 py-lg-10 py-6">
          <div className="col-12 col-lg-12">
          <div className="card shadow-none bg-white p-6 text-center mt-8">
            <div className="d-flex justify-content-between align-items-center mt-4 mb-3">
              <h2 className="text-dark mb-0">Messages</h2>
              <button
                className="btn btn-purple btn-lg rounded-pill"
                onClick={() => navigate(-1)}
              >
                Go Back
              </button>
            </div>

            <p className="text-muted mb-4 mt-8">
              Current under maintenance. Please check back later.
            </p>
          </div>
          </div>
        </div>
      </div>
      </>
      }

     <Footer />
    </div>
  );
};

export default Message;
